import { Component, inject } from '@angular/core';
import { TokenService } from '../../../service/token.service';
import { IonicModule, LoadingController } from '@ionic/angular';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [IonicModule, RouterModule],
})
export class SidebarComponent {
  private loadingCtrl = inject(LoadingController);
  private tokenService = inject(TokenService);

  async logout() {
    const loading = await this.loadingCtrl.create();
    await loading.present();
    this.tokenService.clearToken();
    location.reload();
  }
}
